<template>
	<main :class="{product,page}">
		<page-content v-if="page" :slug="slug" />
		<div v-else>	
			<article class="page-body lost">
				<h1>Page Not Found</h1>
				<p>Unfortunately we were not able to find the page you are looking for.</p>				
			</article>
		</div>
	</main>
</template>

<script>
import { pagesComputed } from '@/features/pages/store'
import { productsComputed } from '@/features/products/store'
import ProductPageDisplay from '@/features/products/components/public/ProductPageDisplay'
export default {
	components: {
		ProductPageDisplay
	},
	computed: {
        ...pagesComputed,
		...productsComputed,
        page() {
			return this.pages.find(temp => '/'+temp.slug == this.$route.path)
		},					
		slug() {
			return this.$route.path.substring(1)
		},
    }
}
</script>
